import React, { useState } from "react";
import {config, LABELS, service, useFetchData, useTextarea} from "../utils";
import { Button, ComponentRenderer } from ".";

const OtherIssues = () => {

  const {response, status} = useFetchData(config.PAGE_ID.OTHER_ISSUES);
  const {value, onChange} = useTextarea();

  const [postApiState, setState] = useState({
    response: {},
    postStatus: config.STATUS.NS,
  })

  const handleClick = async () => {
    service.trackClick(config.NEED_HELP_TRACKING.NEED_HELP, config.CTA_TRACKING_ID.FEEDBACK);
    setState({
      ...postApiState,
      postStatus: config.STATUS.IP,
    });
    const response = await service.submit(config.PAGE_ID.OTHER_ISSUES, {
      feedbackText: value,
    });
    setState({
      ...postApiState,
      response,
      postStatus: config.STATUS.D
    });
  };

  const disableButton = () => {
    return (
      postApiState.postStatus === config.STATUS.IP ||
      !service.trimTrailingSpaces(value)
    );
  }

  const { headerText = "", buttonText = "" } = response;
  return (
    <ComponentRenderer status={status} response={response} postApiState={postApiState}>
        <React.Fragment>
          <p>{headerText}</p>
          <textarea
            className="reviewTextArea"
            placeholder={LABELS.OTHER_ISSUES_PLACEHOLDER}
            onChange={onChange}
            value={value}
          ></textarea>

          <Button
            disable={disableButton()}
            onClick={handleClick}
            label={buttonText}
          />
        </React.Fragment>
    
    </ComponentRenderer>
  )
}

export default OtherIssues;
